import * as React from "react";
import { Box, Link, Typography } from "@mui/material";
import { getCurrentBrand } from "@/config/brands";

function Copyright(props) {
  const brand = getCurrentBrand();
  return (
    <Typography
      variant="body2"
      color={brand.footerCopyrightTextColor}
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link
        color="inherit"
        href={`https://www.${brand.domain}`}
        sx={{ textDecoration: "none" }}
      >
        {brand.name}
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const brand = getCurrentBrand();
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: "auto",
        borderTop: `1px solid ${brand.footerDividerColor}`,
        backgroundColor: brand.footerPrimaryColor,
      }}
    >
      <Copyright />
    </Box>
  );
}
